// components/Navbar.js
import { NavLink } from 'react-router-dom';
import '../styles/Navbar.css';

function Navbar() {
  return (
    <nav>
      <NavLink to="/" activeClassName="active">Personal Info</NavLink>
      <NavLink to="/work-experience" activeClassName="active">Work Experience</NavLink>
      <NavLink to="/education" activeClassName="active">Education</NavLink>
      <NavLink to="/skills" activeClassName="active">Skills</NavLink>
      <NavLink to="/projects" activeClassName="active">Projects</NavLink>
    </nav>
  );
}

export default Navbar;
